import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './app/app';
import { initAnalytics } from './lib/analytics';
import './index.css';

initAnalytics();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found');

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
